export enum VoidGapFiltersEnum {
    Default = 'Default',
    TenantCategory = 'Tenant Category', 
    MarketPresenceAndVoid = 'Market Presence and Void',
    SquareFootage = 'Square Footage', 
    UnitsAndGrowth = 'Units and Growth'
}